import axios from 'axios'

const client = axios.create({
    baseURL: `${process.env.REACT_APP_ZPAY_BASE_URL}`,
    timeout: 30000
})

export const createTransaction = (productId, locationId, amountInMinor, type, locale) => {
    return client.post('/zpay/create', {
        product_id: productId,
        location_id: locationId,
        amount_in_minor_object: amountInMinor,
        type,
        locale,
    }).then(result => {
        return result
    }).catch(error => {
        if (error instanceof Error) {
            return Promise.reject(error)
        }

        return Promise.reject(new Error(error.ErrorMessage || error.resultCode))
    })
}

export const getTransactionStatus = (paymentId, signature) => {
    return client.get(`/zpay/status/${paymentId}`, {
        params: {
            signature,
        },
    })
}

export const setTransactionStatus = (id, expiry, signature) => {
    return client.post(`/zpay/mark_redeemed/${id}?expires=${expiry}&signature=${signature}`)
}

export const validateRedemptionCode = (code, productId, locationId) => {
    return client.get(`/zpay/code_redeemable`, {
        params: {
            product_id: productId,
            location_id: locationId,
            redeem_code: code,
        },
    })
}
